import type { Product, ProductAudience } from '@/types'

export type { ProductAudience }

export const PRODUCT_AUDIENCE_OPTIONS: {
  value: ProductAudience
  label: string
}[] = [
  { value: 'men', label: 'Men' },
  { value: 'women', label: 'Women' },
  { value: 'both', label: 'Men & Women' },
]

export function parseProductAudience(
  value: unknown
): ProductAudience | undefined {
  if (value === 'men' || value === 'women' || value === 'both') {
    return value
  }
  return undefined
}

export function productAudienceLabel(
  audience: ProductAudience | undefined
): string | undefined {
  if (!audience) return undefined
  return PRODUCT_AUDIENCE_OPTIONS.find((o) => o.value === audience)?.label
}

export function productAudienceDescription(
  audience: ProductAudience
): string {
  switch (audience) {
    case 'men':
      return 'This fragrance is crafted especially for men.'
    case 'women':
      return 'This fragrance is crafted especially for women.'
    case 'both':
      return 'This fragrance suits both men and women.'
  }
}

export function productHasAudience(
  product: Pick<Product, 'audience'>
): product is Product & { audience: ProductAudience } {
  return product.audience != null
}
